<template>
  <v-dialog v-model="show" width="25%" persistent>
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><b>تأكيد رمز التحقق</b></h4>
        <button type="button" @click="onCancel" class="modal-close">
          <i class="fa fa-times fa-lg" aria-hidden="true"></i>
        </button>
      </div>
      <ValidationObserver ref="formObserver" v-slot="{ invalid }">
        <v-form ref="form">
          <div class="modal-body text-center">
            <h5 class="pb-5 pt-2"><b>الرجاء إدخال رمز التحقق المرسل إلى جوالك</b></h5>
            <template>
              <div class="ma-auto otp-input" style="max-width: 260px">
                <validation-provider name="otp" v-slot="{ errors }" rules="required|otp">
                  <v-input :error-messages="errors" v-model="otp">
                    <v-otp-input ref="otpInput" length="4" type="number" :value="otp"
                      @input="onInput($event)"></v-otp-input>
                  </v-input>
                </validation-provider>
              </div>
            </template>
            <p class="p-1"> الوقت المتبقي لانتهاء مدة رمز التحقق {{ timerCount | fancyTimeFormat }} </p>
            <a :class="timerCount == 0 ? 'btn' : 'btn disabled'" href="#" @click="resendOtp"><b>
                إعادة إرسال رمز التحقق</b></a>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-link text-danger mr-auto px-8 text-decoration-none"
              @click="onCancel"><b>إلغاء</b></button>
            <button type="button" class="btn button--greenFill px-8 text-white" @click="onVerify"
              :disabled="invalid">تحقق</button>
          </div>
        </v-form>
      </ValidationObserver>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import { OTPRefrenceDataModel } from '@/models/OTPRefrenceDataModel';
import ExternalService from '@/services/external';
import { Toaster } from '@/services/toast';

@Component({
  diProvide: [
    ExternalService,
  ],
})
export default class OtpComponent extends Vue {
  /** The external service instance. */
  @Inject(ExternalService) public externalService!: ExternalService;

  /** The user's national identifier. */
  @Prop({ default: '' }) nationalId!: string;

  /** Toggle the OTP dialog modal. */
  show = false;

  /** The one time password value. */
  otp = '';

  /** The one time password reference data. */
  otpData: OTPRefrenceDataModel = {} as OTPRefrenceDataModel;

  timerCount = 30;

  async sendOtp(): Promise<void> {
    const result = await this.externalService.sendOTP(this.nationalId);

    if (result.statusCode === 200) {
      this.otpData = result.model;
      this.timerCount = this.otpData.maxMinutesRetries ? this.otpData.maxMinutesRetries * 60 : 1;
      this.startTimer();
      this.show = true;
    }
  }

  async resendOtp(): Promise<void> {
    if (this.otpData?.reference) {
      const result = await this.externalService.sendOTP(this.nationalId, this.otpData.reference);

      if (result.statusCode === 200) {
        this.otpData = result.model;
        this.timerCount = this.otpData.maxMinutesRetries ? this.otpData.maxMinutesRetries * 60 : 1;
        this.startTimer();
        Toaster.success({ message: 'تم إرسال رمز جديد إلى الجوال' });
      } else if (result.statusCode === 400) {
        if (result.errorCode === 'ERR_OTPMaxRetries') {
          Toaster.error({ message: result.errorMessage });
          this.show = false;
        } else {
          Toaster.error({ message: result.errorMessage });
        }
      }
    }
  }

  onInput(value: string): void {
    this.otp = value;
  }

  /**
   * Handles the verify event and emits the OTP data.
   */
  async onVerify(): Promise<void> {
    const isValid = await (this.$refs.formObserver as any).validate();
    if (!isValid) return;
    this.otpData.otp = this.otp;
    this.$emit('verify', this.otpData);
  }

  startTimer() {
    this.countDownTimer();
  }

  countDownTimer() {
    if (this.timerCount > 0) {
      setTimeout(() => {
        this.timerCount -= 1;
        this.countDownTimer();
      }, 1000);
    }
  }

  onCancel(): void {
    this.reset();
  }

  /**
   * Reset everything.
   */
  private reset(): void {
    this.show = false;
    (this.$refs.formObserver as any).reset();
    (this.$refs.form as any).reset();
    this.otp = '';
    this.timerCount = 30;
  }

  @Watch('show')
  onShowChanged(value: boolean) {
    if (value) {
      setTimeout(() => {
        (this.$refs.otpInput as any).focus();
      }, 100);
    }
  }
}
</script>
